// extracted by mini-css-extract-plugin
module.exports = {"tableBodyCell":"SkeletonCalculationRowItem_tableBodyCell__2VleH"};